import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.words');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, getAdminT } from "src/libs/portal/korslovo/i18n";

@Component({
    selector: 'wiz-page-admin-words',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.words/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: auto;
}`],
})
export class PageAdminWordsComponent implements OnInit, OnDestroy {
    public ru = RU;
    public t: any = RU;
    public categories: any[] = [];
    public lessons: any[] = [];
    public selectedCategory: string = '';
    public selectedLesson: string = '';
    public list: any[] = [];
    public loading: boolean = true;

    public showModal: boolean = false;
    public editing: any = null;
    public form: any = {};
    public saving: boolean = false;

    public showImport: boolean = false;
    public csvText: string = '';
    public importing: boolean = false;

    public showPreview: boolean = false;
    public previewWord: any = null;
    public uploading: boolean = false;

    // Bulk edit mode
    public bulkMode: boolean = false;
    public bulkData: any[] = [];
    public bulkSaving: boolean = false;

    // Conflict detection
    public showConflicts: boolean = false;
    public conflicts: any[] = [];
    public detectingConflicts: boolean = false;

    // Pagination
    public page: number = 1;
    public dump: number = 30;
    public total: number = 0;
    public searchText: string = '';
    private langListener: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.t = getAdminT();
        this.langListener = async () => { this.t = getAdminT(); await this.service.render(); };
        window.addEventListener('admin-lang-change', this.langListener);
        await this.loadCategories();
    }

    ngOnDestroy() {
        if (this.langListener) window.removeEventListener('admin-lang-change', this.langListener);
    }

    public async loadCategories() {
        const { code, data } = await wiz.call("categories");
        if (code === 200) {
            this.categories = data || [];
            if (this.categories.length > 0 && !this.selectedCategory) {
                this.selectedCategory = this.categories[0].id;
            }
        }
        await this.loadLessons();
    }

    public async onCategoryChange() {
        this.selectedLesson = '';
        await this.loadLessons();
    }

    public async loadLessons() {
        if (!this.selectedCategory) {
            this.lessons = [];
            this.list = [];
            this.loading = false;
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("lessons", { category_id: this.selectedCategory });
        if (code === 200) {
            this.lessons = data || [];
            if (this.lessons.length > 0 && !this.selectedLesson) {
                this.selectedLesson = this.lessons[0].id;
            }
        }
        await this.loadWords();
    }

    public async onLessonChange() {
        this.bulkMode = false;
        this.page = 1;
        this.searchText = '';
        await this.loadWords();
    }

    public async loadWords() {
        if (!this.selectedLesson) {
            this.list = [];
            this.total = 0;
            this.loading = false;
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();
        const res = await wiz.call("list", {
            lesson_id: this.selectedLesson,
            page: this.page,
            dump: this.dump,
            search: this.searchText
        });
        if (res.code === 200) {
            this.list = res.data?.rows || [];
            this.total = res.data?.total || 0;
        }
        this.loading = false;
        await this.service.render();
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.loadWords();
    }

    public async onSearch() {
        this.page = 1;
        await this.loadWords();
    }

    public openCreate() {
        this.editing = null;
        this.form = {
            lesson_id: this.selectedLesson,
            korean: '', pronunciation: '', russian: '',
            example_ko: '', example_ru: '',
            audio_url: '', example_audio_url: '', audio_type: 'tts',
            sort_order: this.list.length, status: 'active',
            accepted_answers: '', accepted_hint: '', description_ru: '',
        };
        this.showModal = true;
        this.service.render();
    }

    public openEdit(item: any) {
        this.editing = item;
        const acceptedStr = (item.accepted_list || []).join(', ');
        this.form = {
            lesson_id: item.lesson_id || this.selectedLesson,
            korean: item.korean || '', pronunciation: item.pronunciation || '',
            russian: item.russian || '',
            example_ko: item.example_ko || '', example_ru: item.example_ru || '',
            audio_url: item.audio_url || '', example_audio_url: item.example_audio_url || '',
            audio_type: item.audio_type || 'tts',
            sort_order: item.sort_order || 0, status: item.status || 'active',
            accepted_answers: acceptedStr, accepted_hint: item.accepted_hint || '',
            description_ru: item.description_ru || '',
        };
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.editing = null;
        this.service.render();
    }

    public async save() {
        if (!this.form.korean || !this.form.russian) {
            await this.service.modal.error("Заполните корейское слово и русский перевод (한국어 단어와 러시아어 번역을 입력하세요)");
            return;
        }
        this.saving = true;
        await this.service.render();

        let res;
        if (this.editing) {
            res = await wiz.call("update", { id: this.editing.id, ...this.form });
        } else {
            res = await wiz.call("create", this.form);
        }
        this.saving = false;
        if (res.code === 200) {
            this.closeModal();
            await this.loadWords();
        } else {
            await this.service.modal.error(res.data?.message || "Ошибка сохранения (저장 오류)");
            await this.service.render();
        }
    }

    public async delete(item: any) {
        const confirmed = await this.service.modal.show({
            title: 'Удалить слово? (단어 삭제?)',
            message: `«${item.korean} — ${item.russian}» будет удалено. (삭제됩니다.)`,
            action: 'Удалить (삭제)', status: 'error'
        });
        if (!confirmed) return;
        const { code } = await wiz.call("delete", { id: item.id });
        if (code === 200) await this.loadWords();
    }

    public preview(item: any) {
        this.previewWord = item;
        this.showPreview = true;
        this.service.render();
    }

    public closePreview() {
        this.showPreview = false;
        this.previewWord = null;
        this.service.render();
    }

    public openImport() {
        this.csvText = '';
        this.showImport = true;
        this.service.render();
    }

    public closeImport() {
        this.showImport = false;
        this.service.render();
    }

    public async doImport() {
        if (!this.csvText.trim()) {
            await this.service.modal.error("CSV 데이터를 입력해주세요");
            return;
        }
        if (!this.selectedLesson) {
            await this.service.modal.error("Сначала выберите урок (먼저 레슨을 선택하세요)");
            return;
        }
        this.importing = true;
        await this.service.render();
        const { code, data } = await wiz.call("import_csv", {
            lesson_id: this.selectedLesson, csv: this.csvText
        });
        this.importing = false;
        if (code === 200) {
            await this.service.modal.success(`Импортировано (가져옴): ${data.count} слов (단어)`);
            this.closeImport();
            await this.loadWords();
        } else {
            await this.service.modal.error(data?.message || "Ошибка импорта (가져오기 오류)");
            await this.service.render();
        }
    }

    // ─── Bulk edit ───
    public async toggleBulkMode() {
        this.bulkMode = !this.bulkMode;
        if (this.bulkMode) {
            this.bulkData = this.list.map(item => ({
                id: item.id, korean: item.korean, russian: item.russian,
                accepted_answers: (item.accepted_list || []).join(', '),
                accepted_hint: item.accepted_hint || '',
                description_ru: item.description_ru || '',
                _changed: false,
            }));
        }
        await this.service.render();
    }

    public markBulkChanged(item: any) { item._changed = true; }

    public async saveBulk() {
        const changed = this.bulkData.filter(d => d._changed);
        if (changed.length === 0) {
            this.bulkMode = false;
            await this.service.render();
            return;
        }
        this.bulkSaving = true;
        await this.service.render();

        const items = changed.map(d => ({
            id: d.id, accepted_answers: d.accepted_answers,
            accepted_hint: d.accepted_hint, description_ru: d.description_ru,
        }));
        const { code, data } = await wiz.call("bulk_update_accepted", {
            items: JSON.stringify(items)
        });
        this.bulkSaving = false;
        if (code === 200) {
            await this.service.modal.success(`Обновлено (수정): ${data.updated} слов (단어)`);
            this.bulkMode = false;
            await this.loadWords();
        } else {
            await this.service.modal.error(data?.message || "Ошибка (오류)");
            await this.service.render();
        }
    }

    // ─── Auto descriptions ───
    public async autoDescriptions() {
        if (!this.selectedLesson) return;
        const { code, data } = await wiz.call("auto_descriptions", {
            lesson_id: this.selectedLesson
        });
        if (code === 200) {
            await this.service.modal.success(`Сгенерировано (생성): ${data.updated} описаний (설명)`);
            await this.loadWords();
        }
    }

    // ─── Conflict detection ───
    public async detectConflicts() {
        this.detectingConflicts = true;
        this.showConflicts = true;
        this.conflicts = [];
        await this.service.render();
        const { code, data } = await wiz.call("detect_conflicts");
        this.detectingConflicts = false;
        if (code === 200) this.conflicts = data.conflicts || [];
        await this.service.render();
    }

    public closeConflicts() {
        this.showConflicts = false;
        this.service.render();
    }

    // ─── Migrate ───
    public async runMigrate() {
        const { code, data } = await wiz.call("migrate");
        if (code === 200) {
            await this.service.modal.success(`Migration: ${(data.results || []).join(', ')}`);
        }
    }

    // ─── Audio ───
    public speak(text: string) {
        if ('speechSynthesis' in window) {
            const u = new SpeechSynthesisUtterance(text);
            u.lang = 'ko-KR'; u.rate = 0.8;
            window.speechSynthesis.speak(u);
        }
    }

    public playWord(item: any) {
        if (item.audio_type === 'recorded' && item.audio_url) {
            new Audio(item.audio_url).play();
        } else {
            this.speak(item.korean);
        }
    }

    public async uploadAudio(event: any) {
        const file = event.target?.files?.[0];
        if (!file || !this.editing?.id) return;
        this.uploading = true;
        await this.service.render();
        const formData = new FormData();
        formData.append('audio', file);
        formData.append('word_id', this.editing.id);
        try {
            const res = await fetch(`/wiz/api/page.admin.words/upload_audio`, {
                method: 'POST', body: formData
            });
            const json = await res.json();
            if (json.code === 200) {
                this.form.audio_url = json.data.audio_url;
                this.form.audio_type = 'recorded';
            }
        } catch (e) { }
        this.uploading = false;
        await this.service.render();
    }

    public async deleteAudio() {
        if (!this.editing?.id) return;
        const { code } = await wiz.call("delete_audio", { word_id: this.editing.id });
        if (code === 200) {
            this.form.audio_url = '';
            this.form.audio_type = 'tts';
            await this.service.render();
        }
    }
}

export default PageAdminWordsComponent;